import React, { Component } from 'react'

import TopMenu from './TopMenu'
import Footer from './Footer.js'

class PublicHome extends Component {

  render () {
    const { lang, onChangeLanguage } = this.props

    return (
      <div className='App'>
        <TopMenu userInfo={null} lang={lang} onChangeLanguage={onChangeLanguage} />
        <Footer></Footer>
      </div>
    )
  }
}

export default PublicHome



// WEBPACK FOOTER //
// ./src/components/PublicHome.js